export class Attivita {
    public uuid: string;
    public slug: string;
    public titolo: string;
    public testo: string;
    public immagine_lancio: string;
    public path_immagine: string;
    public lang: string;

    constructor() {
    }
}
